<template>
  <el-dialog title="压缩反馈" :visible.sync="dialogVisible">
    <el-form :model="form" :rules="custom" ref="custom" label-position="left" label-width="100px">
      <el-form-item label="图片来源" prop="source">
        <el-radio-group v-model="form.source">
          <el-radio label="PHONE">手机拍摄</el-radio>
          <el-radio label="SHOOTME">手机截图</el-radio>
          <el-radio label="NETWORK_IMAGE">网络图片</el-radio>
          <el-radio label="OTHER">其他设备</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="其他描述" prop="desc">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5 }"
          v-model="form.desc"
          placeholder="可以描述设备品牌、系统版本、型号等"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitFeedback">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { postFeedback } from '@/api/api';
import { validateFeedbackDesc } from '@/utils/validate';
export default {
  data() {
    return {
      dialogVisible: false,
      fileId: '',
      form: {
        source: 'PHONE',
        desc: '',
      },
      custom: {
        source: [{ required: true, trigger: 'blur' }],
        desc: [{ required: true, trigger: 'blur', validator: validateFeedbackDesc }],
      },
    };
  },
  methods: {
    open(id) {
      this.fileId = id;
      this.dialogVisible = true;
    },
    submitFeedback() {
      this.$refs.custom.validate(async (valid) => {
        if (valid) {
          const res = await postFeedback(this.fileId, this.form);
          if (res.code == 0) {
            this.$message.success('已提交反馈');
            this.dialogVisible = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>